import { useEffect, useMemo, useState } from 'react';
import { getWeeklyEffectiveTimeList } from '@op/services';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import moment from 'moment';
import { DBO_TM, DBO_V } from '@op/utils/format';

interface EffectiveTimeList {
  text: string;
  value: string;
  effectiveTime: {
    start_time: string;
    end_time: string;
  };
}

interface ApiResp {
  id: number;
  game_id: string;
  start_time: string;
  end_time: string;
  positive_summary: string;
  negative_summary: string;
  neutral_summary: string;
  create_time: string;
  update_time: string;
  task_id: string;
}

export function useEffectiveTimeList({ gameInfo }: any) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });

  const [effectiveTime, setEffectiveTime] = useState<string>();
  const [effectiveTimeList, setEffectiveTimeList] = useState<
    EffectiveTimeList[]
  >([]);

  const { defaultTime, filter } = useMemo(() => {
    let defaultTime = moment().format('YYYY-MM-DD');

    if (!DBO_V.is_empty(effectiveTime)) {
      const item = effectiveTimeList.find(item => item.value === effectiveTime);
      if (item) {
        const timeFilter = item.effectiveTime;
        defaultTime = timeFilter?.start_time || defaultTime;
        return {
          defaultTime,
          filter: { ...timeFilter, date_type: 'weekly', ...gameInfo },
        };
      }
    }

    return { defaultTime, filter: null };
  }, [effectiveTime]);

  useEffect(() => {
    wrapperCancelRequest(getWeeklyEffectiveTimeList, gameInfo)
      .then((data: ApiResp[]) => {
        const timesList = data.map(item => {
          const text = DBO_TM.timeTitle({ ...item, date_type: 'daily' });

          const effectiveTime = {
            start_time: item.start_time,
            end_time: item.end_time,
          };

          return { text, value: text, effectiveTime };
        });
        setEffectiveTimeList(timesList);
        setEffectiveTime(timesList[0].value);
      })
      .catch(e => console.log(e));
  }, []);

  return {
    effectiveTime,
    setEffectiveTime,
    effectiveTimeList,
    defaultTime,
    loading,
    filter,
  };
}
